<template>
  <div class>
    <el-menu
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :default-active="defaultActive"
      unique-opened
    >
      <el-menu-item class="tab">
        <div class="sidebar-toggler" @click="collapse">
          <i :class="[isCollapse?'el-icon-arrow-right':'el-icon-arrow-left']"></i>
        </div>
      </el-menu-item>
      <!-- ------ menu ------- -->
      <el-submenu :index="item.href" v-for="(item,index) in menu" :key="index">
        <template slot="title">
          <i :class="item.icon"></i>
          <span slot="title">{{item.name}}</span>
        </template>

        <el-menu-item-group>
          <el-menu-item :index="v.href" v-for="(v,i) in item.children" :key="i">
            <router-link :to="v.href">
              <i :class="v.icon"></i>
              {{v.name}}
            </router-link>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { userMenusApi,menuListApi } from "@/api/api";
export default {
  name: "",
  data() {
    return {
      isCollapse: false,
      menu: [
        {
          name: "系统管理",
          href: "/setting",
          icon: "el-icon-setting",
          children: [
            {
              name: "用户管理",
              icon: "el-icon-s-custom",
              href: "/User"
            },
            {
              name: "字典管理",
              icon: "el-icon-notebook-2",
              href: "/Dict"
            }
          ]
        },
        {
          name:"廉政评价管理",
          href:"",
          icon:"el-icon-notebook-2",
          children: [
            {
              name: "用户反馈管理",
              icon: "el-icon-s-custom",
              href: "/Feedback"
            },
          ]
        }
      ],
      menu2: [],
      userMenu:[],
      defaultActive: ""
    };
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    collapse() {
      this.isCollapse = !this.isCollapse;
      let oBoxR = document.querySelector("#container_right");
      let oBoxL = document.querySelector("#container_left");
      if (this.isCollapse) {
        oBoxL.classList.add("active");
        oBoxR.classList.add("active");
        oBoxL.style.transition = "all ease .43s";
        oBoxR.style.transition = "all ease .43s";
      } else {
        oBoxL.classList.remove("active");
        oBoxR.classList.remove("active");
      }
    }, //不用管 ， 这是侧边栏收缩的平滑效果
    isin(v) {
      return this.userMenu.indexOf(v) != -1;
    },
    isinChild(v) {
      let flag = false;
      v.forEach(item => {
        if(this.isin(item.id)) {
          flag = true;
        }
      })
      return flag;
    }
  },
  created() {
    this.defaultActive = window.location.href.split("?")[0].split("#")[1];
    menuListApi().then(res => {
      this.menu2 = res[0].children;
    })
    userMenusApi().then(res => {
      // console.log(res);
      res.forEach(element => {
        this.userMenu.push(element.id);
      });
    });
  }
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 250px;
  min-height: 400px;
}
.sidebar-toggler {
  border-radius: 4px;
  cursor: pointer;
  display: block;
  float: right;
  margin: 0;
  border: 0;
  margin: 8px 0;
  width: 24px;
  height: 24px;
  margin-right: -1px;
  background-color: #409eff;
  line-height: 24px;
}
.sidebar-toggler i {
  color: #fff !important;
}
/* 选中状态 */
.is-active > a {
  color: #409eff !important;
}
a {
  text-decoration: none;
  color: #333;
  display: inline-block;
  width: 100%;
  height: 100%;
}
.tab {
  height: 40px !important;
  color: #242527 !important;
}
.el-submenu__title {
  height: 36px !important;
  line-height: 36px !important;
  border: 1px solid red !important;
}
.el-menu-item {
  height: 34px !important;
  line-height: 34px !important;
  color: #333 !important;
}
</style>